import { render, staticRenderFns } from "./CreatePermission.vue?vue&type=template&id=4cf87b28&scoped=true&"
import script from "./CreatePermission.vue?vue&type=script&lang=ts&"
export * from "./CreatePermission.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePermission.vue?vue&type=style&index=0&id=4cf87b28&lang=sass&scoped=true&"
import style1 from "./CreatePermission.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf87b28",
  null
  
)

export default component.exports